"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2444,8463],{

/***/ 2444:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ AdsTypeGenerators; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/hooks/useTransition.tsx
var useTransition = __webpack_require__(976);
;// CONCATENATED MODULE: ./src/utils/generateTimeStamp.ts
var generateTimeStamp = function() {
    return new Date().getTime() + Math.floor(Math.random() * 1000);
};
/* harmony default export */ var utils_generateTimeStamp = (generateTimeStamp);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
;// CONCATENATED MODULE: ./src/lib/ads.ts
/* eslint-disable @typescript-eslint/ban-types */ 
var billboardSizesDefault = [
    [
        970,
        90
    ],
    [
        728,
        90
    ],
    [
        970,
        250
    ], 
];
var rectangleSizesDefault = [
    [
        300,
        250
    ],
    [
        336,
        280
    ], 
];
var rectangleSizesDefaultPlus = [
    [
        160,
        600
    ],
    [
        300,
        50
    ],
    [
        300,
        75
    ],
    [
        300,
        100
    ],
    [
        300,
        600
    ],
    [
        320,
        50
    ],
    [
        320,
        100
    ],
    [
        320,
        480
    ], 
].concat((0,_to_consumable_array/* default */.Z)(rectangleSizesDefault));
var AdsDefs = {
    billboard: {
        sizes: billboardSizesDefault,
        enableMobile: false,
        enableDesktop: true,
        children: {
            main: {
                children: {
                    home: {
                        sizes: billboardSizesDefault,
                        enableMobile: false,
                        enableDesktop: true
                    },
                    listing: {
                        sizes: billboardSizesDefault,
                        enableMobile: false,
                        enableDesktop: true
                    }
                }
            },
            footer: {
                sizes: billboardSizesDefault,
                enableMobile: false,
                enableDesktop: true
            }
        }
    },
    rectangle: {
        children: {
            main: {
                children: {
                    home: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: false
                    },
                    listing: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: false
                    },
                    internal: {
                        sizes: rectangleSizesDefaultPlus,
                        enableMobile: true,
                        enableDesktop: true
                    }
                }
            },
            side: {
                sizes: rectangleSizesDefault,
                enableMobile: false,
                enableDesktop: true
            },
            footer: {
                sizes: rectangleSizesDefaultPlus,
                enableMobile: true,
                enableDesktop: false
            },
            collector: {
                sizes: rectangleSizesDefault,
                enableMobile: true,
                enableDesktop: true
            }
        }
    },
    halfpage: {
        sizes: [
            [
                300,
                600
            ],
            [
                120,
                600
            ],
            [
                160,
                600
            ]
        ].concat((0,_to_consumable_array/* default */.Z)(rectangleSizesDefault)),
        enableMobile: false,
        enableDesktop: true
    },
    background: {
        children: {
            "bg-topo-desktop": {
                sizes: [
                    [
                        2000,
                        750
                    ]
                ].concat((0,_to_consumable_array/* default */.Z)(billboardSizesDefault)),
                enableMobile: false,
                enableDesktop: true
            },
            "topo-mobile": {
                sizes: [
                    [
                        2000,
                        750
                    ],
                    [
                        300,
                        50
                    ],
                    [
                        300,
                        100
                    ],
                    [
                        320,
                        50
                    ],
                    [
                        320,
                        100
                    ], 
                ],
                enableMobile: true,
                enableDesktop: false
            }
        }
    },
    anchor: {
        sizes: [
            [
                320,
                50
            ],
            [
                300,
                50
            ],
            [
                1,
                1
            ]
        ],
        enableMobile: true,
        enableDesktop: false
    },
    Anchor_Footer: {
        sizes: [
            [
                728,
                90
            ],
            [
                970,
                90
            ],
            [
                1,
                1
            ]
        ],
        enableMobile: false,
        enableDesktop: true
    },
    Interstitial_2023: {
        sizes: [
            [
                336,
                280
            ],
            [
                300,
                250
            ],
            [
                320,
                480
            ], 
        ],
        enableMobile: true,
        enableDesktop: true
    },
    "1x1": {
        sizes: [
            [
                1,
                1
            ]
        ],
        enableMobile: true,
        enableDesktop: true
    }
};
function getSizesByAdType(adType) {
    var adTypeSplit = adType.replace(/-\d+$/, "").split("/");
    var sizes = [
        []
    ];
    var currentObj = AdsDefs;
    adTypeSplit.forEach(function(key, index) {
        var ref;
        if (((ref = currentObj[key]) === null || ref === void 0 ? void 0 : ref.children) && index < adTypeSplit.length - 1) {
            var ref1;
            currentObj = (ref1 = currentObj[key]) === null || ref1 === void 0 ? void 0 : ref1.children;
        } else {
            var ref2;
            sizes = (ref2 = currentObj[key]) === null || ref2 === void 0 ? void 0 : ref2.sizes;
        }
    });
    return sizes;
}
function getDevicesByAdType(adType) {
    var adTypeSplit = adType.replace(/-\d+$/, "").split("/");
    var devices;
    var currentObj = AdsDefs;
    adTypeSplit.forEach(function(key, index) {
        var ref;
        if (((ref = currentObj[key]) === null || ref === void 0 ? void 0 : ref.children) && index < adTypeSplit.length - 1) {
            var ref1;
            currentObj = (ref1 = currentObj[key]) === null || ref1 === void 0 ? void 0 : ref1.children;
        } else {
            var ref2, ref3;
            devices = {
                desktop: (ref2 = currentObj[key]) === null || ref2 === void 0 ? void 0 : ref2.enableDesktop,
                mobile: (ref3 = currentObj[key]) === null || ref3 === void 0 ? void 0 : ref3.enableMobile
            };
        }
    });
    return devices;
}

// EXTERNAL MODULE: ./src/hooks/useBreakpoint.ts
var useBreakpoint = __webpack_require__(2140);
// EXTERNAL MODULE: ./src/utils/className.ts
var className = __webpack_require__(9659);
// EXTERNAL MODULE: ./src/hooks/useScriptFlag.ts
var useScriptFlag = __webpack_require__(1436);
;// CONCATENATED MODULE: ./src/components/Ads/Google/AdsTypeGenerators/index.tsx









/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
    className: "desktop:m-0"
});
var variants = {
    allDevices: {
        true: "flex self-center justify-self-center",
        false: ""
    },
    desktopOnly: {
        true: "hidden p-0 m-0 desktop:flex desktop:self-center desktop:justify-self-center",
        false: ""
    },
    mobileOnly: {
        true: "flex self-center justify-self-center desktop:hidden desktop:p-0 desktop:m-0 [grid-column-start:1] [grid-column-end:2] tablet:[grid-column-start:initial] tablet:[grid-column-end:initial]",
        false: ""
    },
    rectangle: {
        true: "items-center justify-center bg-black/5 w-[336px] h-[300px]",
        false: ""
    },
    halfpage: {
        true: "items-center justify-center bg-black/5 w-[336px] min-h-[300px]",
        false: ""
    },
    manualFlyingCarpet: {
        true: "manual-flying-carpet",
        false: ""
    },
    billboard: {
        true: "hidden p-0 m-0 desktop:flex desktop:justify-center desktop:items-center desktop:my-6 desktop:mx-auto desktop:bg-black/5 desktop:w-[970px] desktop:h-[250px]",
        false: ""
    }
};
function AdsTypeGenerators(param) {
    var type = param.type, _idCountPosition = param.idCountPosition, idCountPosition = _idCountPosition === void 0 ? "" : _idCountPosition, _marginBottomP = param.marginBottomP, marginBottomP = _marginBottomP === void 0 ? "0px" : _marginBottomP;
    var isTransitioning = (0,useTransition/* useTransition */.Y)().isTransitioning;
    var ref = (0,_sliced_to_array/* default */.Z)((0,useBreakpoint/* default */.Z)("tablet"), 1), isTabletOrMobile = ref[0];
    var shouldRenderAds = (0,useScriptFlag/* default */.Z)({
        adFlag: "google"
    });
    var ref1 = (0,react.useState)(false), hasScrolled = ref1[0], setIsScrolled = ref1[1];
    var idTimeStampUnique = utils_generateTimeStamp();
    var tag = (0,react.useRef)("div-gpt-ad-".concat(type, "-").concat(idCountPosition !== "" ? "".concat(idCountPosition, "-").concat(idTimeStampUnique) : idTimeStampUnique));
    var ref2 = getDevicesByAdType(type), mobile = ref2.mobile, desktop = ref2.desktop;
    var isNotAnchor = type !== "anchor" && type !== "Anchor_Footer";
    if (type === "anchor" || type === "Anchor_Footer") {
        document.addEventListener("scroll", function() {
            if (hasScrolled) {
                return;
            }
            setIsScrolled(true);
        });
    }
    (0,react.useEffect)(function() {
        var isTargetAd = type.includes("rectangle") || type.includes("billboard");
        if (isTargetAd) {
            var ref = window || [], adContainerReadyFired = ref.adContainerReadyFired, dataLayer = ref.dataLayer;
            if (!adContainerReadyFired) {
                dataLayer.push({
                    event: "ad_container_ready"
                });
                window.adContainerReadyFired = true;
            }
        }
    }, [
        type
    ]);
    (0,react.useEffect)(function() {
        if (type === "Anchor_Footer" && isTabletOrMobile || type === "anchor" && isTabletOrMobile === false) return;
        if (mobile && isTabletOrMobile || desktop && !isTabletOrMobile) {
            if (isTransitioning || "object" === undefined || !shouldRenderAds) {
                return;
            }
            if (type === "billboard/main/home" || type === "rectangle/main/internal" || type === "halfpage") {
                return;
            }
        }
    }, [
        type,
        idCountPosition,
        isTabletOrMobile,
        isTransitioning,
        hasScrolled,
        mobile,
        desktop,
        shouldRenderAds
    ]);
    if (isNotAnchor) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            id: tag.current,
            style: {
                marginBottom: marginBottomP
            },
            "data-ad": "true",
            className: (0,className/* default */.Z)(variants.manualFlyingCarpet[(!!getSizesByAdType(type).find(function(sizes) {
                return sizes[1] > 300;
            }) && type !== "halfpage").toString()], variants.allDevices[(mobile && desktop).toString()], variants.mobileOnly[(mobile && !desktop).toString()], variants.desktopOnly[(desktop && !mobile).toString()], variants.billboard[type.includes("billboard").toString()], variants.rectangle[type.includes("rectangle").toString()], variants.halfpage[(type === "halfpage").toString()], "".concat(type).concat(idCountPosition !== "" ? "-".concat(idCountPosition, " ") : ""))
        });
    }
    if (!isNotAnchor) {
        if (type === "Anchor_Footer" && isTabletOrMobile || type === "anchor" && isTabletOrMobile === false) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (0,className/* default */.Z)("fixed bottom-0 z-[999] flex  w-full flex-row items-center justify-center border bg-mglGray50 bg-opacity-20 backdrop-blur-sm tablet:w-[calc(100%_-_60px)]", hasScrolled ? "h-[50px] tablet:h-[90px]" : ""),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: tag.current,
                className: (0,className/* default */.Z)(type, "flex flex-row items-center justify-center"),
                "data-ad": "true"
            })
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
}


/***/ }),

/***/ 1436:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useScriptFlag; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);


var publicRuntimeConfig = next_config__WEBPACK_IMPORTED_MODULE_1___default()().publicRuntimeConfig;
function useScriptFlag(param) {
    var adFlag = param.adFlag;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (publicRuntimeConfig.NEXT_PUBLIC_ENVIRONMENT === "production") return true;
    var flags = {
        google: "google",
        mgid: "mgid",
        cazamba: "cazamba"
    };
    if (flags[adFlag] in router.query) {
        if (router.query[flags[adFlag]] === "0") return false;
    }
    return true;
}


/***/ })

}]);